const ArrowScrollIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='33.29' height='12.02' viewBox='0 0 33.29 12.02'>
            <title>アセット 1</title>
            <g id='レイヤー_2' data-name='レイヤー 2'>
                <g id='レイヤー_1-2' data-name='レイヤー 1'>
                    <line x1='1.85' y1='6.01' x2='10.4' y2='6.01' fill='#fff' />
                    <path d='M10.4,7.17H1.85a1.16,1.16,0,1,1,0-2.31H10.4a1.16,1.16,0,1,1,0,2.31Z' fill='#fff' />
                    <path d='M7.4,12a1.15,1.15,0,0,1-.72-.25l-6.25-5A1.2,1.2,0,0,1,0,5.87,1.14,1.14,0,0,1,.46,5L6.7.23A1.16,1.16,0,0,1,8.1,2.08L3,5.91,8.12,10A1.16,1.16,0,0,1,7.4,12Z' fill='#fff' />
                    <line x1='31.45' y1='6.01' x2='22.89' y2='6.01' fill='#fff' />
                    <path d='M31.45,7.17H22.89a1.16,1.16,0,1,1,0-2.31h8.56a1.16,1.16,0,0,1,0,2.31Z' fill='#fff' />
                    <path d='M25.9,12a1.18,1.18,0,0,1-.91-.43A1.17,1.17,0,0,1,25.17,10l5.09-4.05L25.2,2.08A1.16,1.16,0,0,1,26.59.23L32.84,5a1.16,1.16,0,0,1,.45.91,1.14,1.14,0,0,1-.43.92l-6.24,5A1.17,1.17,0,0,1,25.9,12Z' fill='#fff' />
                </g>
            </g>
        </svg>
    );
};

export default ArrowScrollIcon;
